export default defineNuxtRouteMiddleware(() => {
  const { user } = useAuth();
  const localeRoute = useLocaleRoute();

  if (user.value?.role !== "worker") {
    return navigateTo(localeRoute("/profile"), { replace: true });
  }
});
